import { withViewedCianIdsState } from './withViewedCianIdsState';
import { ICluster } from '../../repositories/dailyrent/entities/cluster/Cluster';
import { IFeaturesMap } from '../../types/map';

// Мультипин: кластер не раскрывается в «ромашку», а становится одной фичей со всеми
// своими объявлениями. pinsCount = 1 даёт в сетке единственный центральный слот, поэтому
// раскрытие координат, anchor и zIndex работают как для одиночного пина без ветвлений.
// offersCount кормит каунтер, полный offers — цену «от», иконки и будущий слайдер превью.
export function convertClustersToMultipinFeaturesMap(
  clusters: ICluster[],
  viewedCianIds: Record<number, true>,
): IFeaturesMap {
  return (
    clusters?.reduce<IFeaturesMap>((result, cluster) => {
      const { coordinates, geohash, offers } = cluster;

      if (!offers?.length) {
        return result;
      }

      result[geohash] = {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [coordinates.lat, coordinates.lng],
        },
        id: geohash,
        properties: {
          ...cluster,
          pinIndex: 0,
          pinsCount: 1,
          offersCount: offers.length,
          offers: offers.map(offer => withViewedCianIdsState(offer, viewedCianIds)),
        },
      };

      return result;
    }, {}) ?? {}
  );
}
